var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB1BatteryAutonomyUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "rotate(-90)"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 46.38l-16-7.71V34l12 6V28.87l14 7.63v-5.92l8 8-8 8v-5.53l-10-5.44v10.77zM71 31v14h-5v6a4 4 0 01-4 4H10a4 4 0 01-4-3.86V24.92A4 4 0 0110 21h52a4 4 0 014 4v6h5zm-9-6H10v26h52V25z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/B1_Battery_autonomy_up.04cfb70b.svg";
export { SvgB1BatteryAutonomyUp as ReactComponent };